import { Container, Box, Typography, Chip } from "@mui/material";
import { BlockType } from "./new";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { PostService } from "../../services/post";
import { IPost } from "../../interfaces/posts";
import getUrl from "../../functions/getUrl";
import formatarData from "../../functions/formatDate";
import SocialMediaButtons from "./components/socialMedias";
import ContactSection from "./components/contacts";
import PreFooter from "../../components/home/preFooter";

const PostPage = () => {

    const { slug } = useParams();

    const instance = new PostService();

    const [post, setPost] = useState<IPost>();

    const getPost = () => {

        console.log('slug', slug)
        if(slug)
            instance.get_one(slug)
        .then(data => {
            console.log('data', data)
            setPost(data);
        })
    }

    useEffect(() => {
        getPost();
    }, []);

    return (
        <>
            <Container sx={{ pt: "2em"}}>
                <Box sx={{ display: "flex", gap: "0.5em", pt: 2, pb: 2}}>
                    {
                        post?.tags?.map( item => <Chip key={item.id} label={item?.name} color="success" variant="outlined"/>)              
                    }
                </Box>
                <Typography>
                    {
                        post?.createdAt ?
                            formatarData(new Date(post?.createdAt))
                        : ""
                    }
                </Typography>

                <Typography 
                    variant="h2"
                    fontWeight={600}
                    color="warning" 
                    sx={{ m: "0 auto", fontSize: "2em"}}
                >{slug}</Typography>
                <Typography variant="subtitle1" color="#838383">{post?.preview}</Typography>
                <hr color="#dddddd"/>
                <SocialMediaButtons />
                <Box component="ul" sx={{ p: 0 }}>
                    {
                        post?.blocks?.map((block, index) => {

                            
                            if(block.type === BlockType.IMAGE && block.filename){
                                let url = getUrl("posts", block.filename);
                                return <img key={index}  style={{ width: "100%" }} src={url}/>
                            }else
                            return (
                                <Box key={index} dangerouslySetInnerHTML={{ __html: block.content }} >
                                </Box>
                            )
                        })
                    }
                </Box>
                <hr color="#dddddd"/>
                <Typography variant="h6" color="warning">Compartilhe nas redes sociais:</Typography>
                <SocialMediaButtons />
                <ContactSection/>
                
            </Container>
            <PreFooter />
        </>
    )
}

export default PostPage;